/**
 * 爱微圈导航 · 壁纸模态
 * 本文件是运行时源（唯一真源）—— 由 tools/split_appjs.py 从 assets/js/app.js 一次性
 * 拆分而来，此后各模块独立维护。**改前端逻辑就改这里**，改完执行 `bash build.sh`
 * 打包成 assets/js/app.min.js（index.php 自动优先引用 .min 产物）。
 * assets/js/app.js 只是拆分时的原始素材，运行时不再加载，勿改。
 */

import { applyWeather, greeting, loadDailyContent, loadWeather, renderClockGreet, renderWeatherPop, tickClock, toggleWeatherPop, weatherGeolocate } from './clock.js';
import { $, $$, API, API_TIMEOUT_MS, CACHE_KEY_LEGACY, DEFAULT_SETTINGS, apiGet, apiPost, bootData, cacheKey, debounce, esc, escAttr, fetchWithTimeout, randomColor, safeUrl, shouldAnimate, state, toast } from './core.js';
import { CAT_ICONS, ICO_CHECK, ICO_COPY, ICO_EDIT, ICO_EXPAND, ICO_PIN, ICO_TRASH, NOTE_COLORS, addNote, addTodo, copyNote, loadCategories, loadNotes, loadTodos, loadWebsiteIcon, loadWebsites, observeWebsiteIcons, openNoteEditor, preloadAdjacentCategories, relTime, renderCategories, renderNotes, renderTodos, renderWebsiteList, startTodoEdit, toggleTodo, websiteIconUrls } from './data.js';
import { showContextMenu, showEditModal, showFolderModal } from './edit.js';
import { BUILTIN_ACTIONS, init } from './main.js';
import { closeModal, createCloudBackup, loadBackupListInto, modalConfirm, openModal, runDataRepair, setupDataButtons, showBackupList, showModalError, showQrSync } from './modal.js';
import { ONBOARDING_STEPS, closeOnboarding, maybeShowOnboarding, nextOnbStep, renderOnbStep, showOnboarding } from './onboarding.js';
import { batchDelete, batchMoveToPage, enforcePageCapacity, getPageCapacity, goNextPage, goPrevPage, initBatchToolbar, loadShortcuts, loadShortcutsRaw, prefetchAdjacentPages, prefetchPage, renderPages, shiftPagesAfterRemoval, switchPage, toggleOrganizeMode, updateBatchToolbar, updatePageArrows } from './pages.js';
import { _readIconStore, _reduceMotion, _saveIconStore, _scFp, cardRenderFp, currentGrid, faviconOf, flipMove, getGridCols, gridRenderFp, persistGridReorder, preconnectUrl, renderCardView, renderCardViewAll, renderIcon, renderShortcuts, renderSkeleton, waitTransition } from './render.js';
import { TAB_TARGETS, bindEngineIconFallback, currentEngine, engineBadgeHtml, engineFamily, fetchSuggestions, handleSearch, hideSuggestions, openTarget, renderEngineBadge, renderEngineDropdown, showEngineAddModal } from './search.js';
import { applySettings, bindSettingsUI, loadSettings, scheduleSave } from './settings.js';
import { bindDonateCard, bindShareCard, detectPayApp, fmtDonateTime, loadDonateRank, renderDonateRank, shareQrSrc, shareTargetUrl, shareTextDesc, shareTextTitle, showAboutModal, showContactModal, showDonateModal, showFeedbackModal, showPrivacyModal, showShareModal, showTermsModal } from './share.js';
import { closeDrawers, closeSidebar, doLogout, formatTime, loadUserCategories, openDrawer, openSidebar, renderProfile, resetDataView, showAccountModal, showAuthModal, showCategoryMgr, showCustomAddModal, showDeleteAccountModal, showEmailChangeModal, showForgotPasswordModal, showPhoneBindModal, showQuickAddModal, showSyncChoiceModal, switchSidebarTab } from './sidebar.js';
import { CACHE_TTL, CATEGORY_ENGINE_MAP, applySearchTabUI, cacheState, disableNotifications, enableNotifications, mapCategoryToEngine, notifyEnabled, restoreCache, setNotifyEnabled, showNotification, submitSiteForReview, syncEnabled, toggleSync, trackVisit } from './sync.js';

export const SWATCH_COLORS = ['#4A90D9', '#10141c', '#1e293b', '#2c5364', '#7597de', '#e1251b', '#e74c3c', '#f39c12', '#21a95f', '#16a085', '#9b59b6', '#ec4899'];

export async function showWallpaperModal() {
    openModal(`
        <div class="modal-title">个性化壁纸</div>
        <div class="wp-modal-tabs" id="wpModalTabs">
            <button class="wp-modal-tab active" data-tab="recommend">🎨 精选推荐</button>
            <button class="wp-modal-tab" data-tab="custom">📤 自定义</button>
            <button class="wp-modal-tab" data-tab="source">🔄 壁纸源</button>
        </div>
        <div class="wp-modal-body" id="wpModalBody"></div>`);
    const body = $('#wpModalBody');
    let galleryData = null;
    let marketData = null;
    let subTab = 'daily';

    const switchTab = (tab) => {
        $$('#wpModalTabs .wp-modal-tab').forEach(x => x.classList.toggle('active', x.dataset.tab === tab));
        if (tab === 'recommend') renderRecommend();
        if (tab === 'custom') renderCustom();
        if (tab === 'source') renderSource();
    };
    $$('#wpModalTabs .wp-modal-tab').forEach(t => t.onclick = () => switchTab(t.dataset.tab));

    /* ---- 1) 精选推荐 ---- */
    const renderRecommend = () => {
        body.innerHTML = `
            <div class="wp-subtabs" id="wpSubTabs">
                <button class="wp-subtab ${subTab === 'daily' ? 'active' : ''}" data-sub="daily">每日推荐</button>
                <button class="wp-subtab ${subTab === 'market' ? 'active' : ''}" data-sub="market">壁纸市场</button>
                <button class="wp-subtab ${subTab === 'gallery' ? 'active' : ''}" data-sub="gallery">渐变</button>
                <button class="wp-subtab ${subTab === 'color' ? 'active' : ''}" data-sub="color">纯色</button>
            </div>
            <div id="wpRecContent"></div>`;
        $$('#wpSubTabs .wp-subtab').forEach(s => s.onclick = () => {
            subTab = s.dataset.sub;
            renderRecommend();
        });
        if (subTab === 'daily') renderDaily();
        if (subTab === 'market') renderMarket();
        if (subTab === 'gallery') renderGallery();
        if (subTab === 'color') renderColors();
    };

    const renderDaily = async () => {
        const c = $('#wpRecContent');
        c.innerHTML = '<div class="wp-empty">加载中…</div>';
        try {
            const d = await apiGet(API.wallpaper + '?action=daily');
            c.innerHTML = `
                <div class="wp-hero" id="wpDailyCard" style="background-image:url('${escAttr(d.url).replace(/'/g, '%27')}')">
                    <div class="wp-hero-info">
                        <div class="wp-hero-title">${esc(d.credit || 'Bing 每日壁纸')}</div>
                        <div class="wp-hero-desc">每天更新一张精选摄影作品 · 点击设为壁纸</div>
                    </div>
                    <div class="wp-hero-check" style="display:${state.settings.wallpaper_type === 'url' && state.settings.wallpaper_url === d.url ? '' : 'none'}">✓</div>
                </div>`;
            $('#wpDailyCard').onclick = () => setWallpaper('url', d.url, d.credit);
        } catch (e) { c.innerHTML = '<div class="wp-empty">加载失败，请稍后重试</div>'; }
    };
    const renderMarket = async () => {
        const c = $('#wpRecContent');
        if (!marketData) {
            c.innerHTML = '<div class="wp-empty">加载中…</div>';
            try { marketData = await apiGet(API.wallpaper + '?action=market'); }
            catch (e) { c.innerHTML = '<div class="wp-empty">加载失败</div>'; return; }
        }
        c.innerHTML = `<div class="wp-market-grid">${marketData.map(w => `
            <div class="wp-market-item ${state.settings.wallpaper_type === 'url' && state.settings.wallpaper_url === w.value ? 'active' : ''}"
                 data-url="${escAttr(w.value)}" data-credit="${escAttr(w.credit || w.name)}"
                 style="background-image:url('${escAttr(w.thumb || w.value).replace(/'/g, '%27')}')">
                <div class="wp-market-name">${esc(w.name)}</div>
                <div class="wp-check">✓</div>
            </div>`).join('')}</div>
            <div class="wp-tip">点击图片即可设为壁纸</div>`;
        $$('.wp-market-item', c).forEach(el => el.onclick = () => setWallpaper('url', el.dataset.url, el.dataset.credit));
    };
    const renderGallery = async () => {
        const c = $('#wpRecContent');
        if (!galleryData) {
            c.innerHTML = '<div class="wp-empty">加载中…</div>';
            try { galleryData = await apiGet(API.wallpaper + '?action=gallery'); }
            catch (e) { c.innerHTML = '<div class="wp-empty">加载失败</div>'; return; }
        }
        const groups = {};
        galleryData.forEach(w => { (groups[w.category] = groups[w.category] || []).push(w); });
        c.innerHTML = Object.entries(groups).map(([cat, items]) => `
            <div class="wp-cat-title">${esc(cat)}</div>
            <div class="wp-grid">${items.map(w => `
                <div class="wp-item ${state.settings.wallpaper_type === 'gradient' && state.settings.wallpaper_gradient === w.value ? 'active' : ''}" data-g="${escAttr(w.value)}" data-n="${escAttr(w.name)}" style="background:${escAttr(w.value)}">
                    <div class="wp-name">${esc(w.name)}</div>
                </div>`).join('')}</div>`).join('');
        $$('.wp-item', c).forEach(el => el.onclick = () => setWallpaper('gradient', el.dataset.g, el.dataset.n));
    };
    const renderColors = () => {
        const c = $('#wpRecContent');
        c.innerHTML = `
            <div class="wp-colors">${SWATCH_COLORS.map(c =>
                `<div class="wp-color ${state.settings.wallpaper_type === 'color' && state.settings.wallpaper_color === c ? 'active' : ''}" data-c="${c}" style="background:${c}"></div>`).join('')}</div>
            <div class="wp-color-custom">
                <label>自定义颜色</label>
                <input type="color" class="form-input" id="wpCustomColor" value="${escAttr(state.settings.wallpaper_color || '#4A90D9')}">
            </div>`;
        $$('.wp-color', c).forEach(el => el.onclick = () => setWallpaper('color', el.dataset.c, ''));
        $('#wpCustomColor').oninput = (e) => setWallpaper('color', e.target.value, '');
    };

    /* ---- 2) 自定义 ---- */
    const renderCustom = () => {
        body.innerHTML = `
            <div class="wp-upload-card">
                <input type="file" id="wpUploadInput" accept="image/png,image/jpeg,image/gif,image/webp" hidden>
                <div class="wp-dropzone" id="wpDropzone">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                    <div class="wp-dropzone-title">点击或拖拽上传本地壁纸</div>
                    <div class="wp-dropzone-desc">支持 PNG / JPG / GIF / WebP，最大 10MB，建议 1920×1080 以上</div>
                </div>
            </div>
            <div class="wp-divider"><span>或输入图片链接</span></div>
            <div class="wp-url-row">
                <input type="text" class="form-input" id="wpCustomUrl" placeholder="https://example.com/wallpaper.jpg" value="${escAttr(state.settings.wallpaper_url || '')}">
                <button class="btn btn-primary" id="wpCustomApply">应用</button>
            </div>`;
        const dropzone = $('#wpDropzone');
        const fileInput = $('#wpUploadInput');
        dropzone.onclick = () => fileInput.click();
        dropzone.ondragover = (e) => { e.preventDefault(); dropzone.classList.add('dragover'); };
        dropzone.ondragleave = () => dropzone.classList.remove('dragover');
        dropzone.ondrop = (e) => {
            e.preventDefault();
            dropzone.classList.remove('dragover');
            const file = e.dataTransfer.files[0];
            if (file) uploadWallpaper(file);
        };
        fileInput.onchange = () => {
            const file = fileInput.files[0];
            if (file) uploadWallpaper(file);
        };
        $('#wpCustomApply').onclick = () => {
            const url = safeUrl($('#wpCustomUrl').value.trim());
            if (!url) { toast('请输入有效的图片地址', 'error'); return; }
            setWallpaper('url', url, '自定义壁纸');
        };
    };
    const uploadWallpaper = async (file) => {
        const btn = $('#wpCustomApply');
        if (btn) { btn.textContent = '上传中…'; btn.disabled = true; }
        try {
            const fd = new FormData();
            fd.append('wallpaper', file);
            const res = await fetch(API.wallpaper + '?action=upload', {
                method: 'POST',
                headers: { 'X-CSRF-Token': state.csrf },
                body: fd,
            }).then(r => r.json());
            if (res.error) throw new Error(res.error);
            setWallpaper('url', res.url, res.credit || '本地上传');
        } catch (e) { toast(e.message || '上传失败', 'error'); }
        finally { if (btn) { btn.textContent = '应用'; btn.disabled = false; } }
    };

    /* ---- 3) 壁纸源 ---- */
    const renderSource = () => {
        const curSource = state.settings.wallpaper_source || 'off';
        const curInterval = state.settings.wallpaper_rotate_interval || 'daily';
        body.innerHTML = `
            <div class="wp-source-intro">开启壁纸源后，系统将按设定频率自动为你更换壁纸</div>
            <div class="source-list" id="wpSourceList">
                ${[
                    { k: 'bing', n: '必应每日壁纸', d: '每天更新一张 Bing 精选摄影作品' },
                    { k: 'picsum', n: 'Picsum 随机图片', d: '高质量随机摄影，每次打开都有惊喜' },
                    { k: 'gradient', n: '渐变轮换', d: '从精选渐变色中随机切换' },
                    { k: 'off', n: '关闭自动换', d: '保持当前壁纸不变' },
                ].map(o => `
                    <label class="source-option ${curSource === o.k ? 'active' : ''}" data-source="${o.k}">
                        <input type="radio" name="wpSource" value="${o.k}" ${curSource === o.k ? 'checked' : ''}>
                        <div class="source-check"><svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg></div>
                        <div class="source-info">
                            <div class="source-name">${o.n}</div>
                            <div class="source-desc">${o.d}</div>
                        </div>
                    </label>`).join('')}
            </div>
            <div class="wp-interval-row">
                <label>更换频率</label>
                <select class="form-input" id="wpInterval">
                    <option value="daily" ${curInterval === 'daily' ? 'selected' : ''}>每天一次</option>
                    <option value="hourly" ${curInterval === 'hourly' ? 'selected' : ''}>每小时一次</option>
                    <option value="every_open" ${curInterval === 'every_open' ? 'selected' : ''}>每次打开</option>
                </select>
            </div>
            <button class="btn btn-primary btn-block" id="wpSourceApply">保存壁纸源设置</button>`;
        $$('.source-option', body).forEach(opt => {
            opt.onclick = () => {
                $$('.source-option', body).forEach(x => x.classList.remove('active'));
                opt.classList.add('active');
                opt.querySelector('input').checked = true;
            };
        });
        $('#wpSourceApply').onclick = async () => {
            const source = $('input[name="wpSource"]:checked', body).value;
            const interval = $('#wpInterval', body).value;
            try {
                await apiPost(API.wallpaper + '?action=set_source', { source, interval });
                state.settings.wallpaper_source = source;
                state.settings.wallpaper_rotate_interval = interval;
                cacheState();
                if (source !== 'off') {
                    try {
                        const pick = await apiGet(API.wallpaper + '?action=random');
                        if (pick && pick.url) {
                            state.settings.wallpaper_type = 'url';
                            state.settings.wallpaper_url = pick.url;
                            state.settings.wallpaper_credit = pick.credit || '';
                            applySettings();
                        }
                    } catch (_) {}
                }
                toast('壁纸源设置已保存', 'success');
            } catch (e) { toast(e.message, 'error'); }
        };
    };

    async function setWallpaper(type, value, credit) {
        try {
            await apiPost(API.wallpaper + '?action=set', { type, value, credit });
            state.settings.wallpaper_type = type;
            if (type === 'color') state.settings.wallpaper_color = value;
            if (type === 'gradient') state.settings.wallpaper_gradient = value;
            if (type === 'url') { state.settings.wallpaper_url = value; state.settings.wallpaper_credit = credit || ''; }
            if (state.settings.wallpaper_source && state.settings.wallpaper_source !== 'off') {
                state.settings.wallpaper_source = 'off';
                apiPost(API.wallpaper + '?action=set_source', { source: 'off', interval: state.settings.wallpaper_rotate_interval || 'daily' }).catch(()=>{});
            }
            applySettings();
            cacheState();
            toast('壁纸已更新', 'success');
            if (subTab === 'gallery') renderGallery();
            if (subTab === 'color') renderColors();
            if (subTab === 'market') renderMarket();
            if (subTab === 'daily') renderDaily();
        } catch (e) { toast(e.message, 'error'); }
    }

    switchTab('recommend');
}

/* ---------- 弹窗框架 ---------- */

